import Capsule from "ui/components/Capsule";
import cx from "ui/cx";
import IconHigharcGrey from "ui/icons/IconHigharcGrey";
import styles from "./ProductName.module.scss";

export interface ProductNameProps extends React.HTMLAttributes<HTMLDivElement> {
  productName: string;
  beta?: boolean;
  mobileLogoOnly?: boolean;
}

export default function ProductName({ productName, beta, title, mobileLogoOnly, className }: ProductNameProps) {
  return (
    <div className={cx(styles.wrapper, mobileLogoOnly && styles.mobileLogoOnly, className)} title={title}>
      <IconHigharcGrey /> <span className={styles.name}>{productName}</span>
      {beta && <Capsule label="BETA" size="smallX1" className={styles.beta} />}
    </div>
  );
}
